import { createSlice } from "@reduxjs/toolkit";
import { getDiscounts } from "./discountsAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  possibleDiscounts: [],
};

const discountsSlice = createSlice({
  name: "discounts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDiscounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDiscounts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.possibleDiscounts = payload;
        state.error = null;
      })
      .addCase(getDiscounts.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});
export default discountsSlice.reducer;
